<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    max-width="1200px"
  >
    <v-card :loading="loading">
      <v-card-title>
        <span>Phản hồi</span>
        <v-spacer/>
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="close()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-menu>
      </v-card-title>
      <v-card-text>
        <v-container>
          <div v-if="errors_exist" class="row">
            <div class="col">
              <v-alert
                dense
                outlined
                type="error"
              >
                {{ $vuetify.lang.t('$vuetify.msg.hasError') }}
                <ul>
                  <div v-for="(error, index) in errors">
                    <li :key="index">{{ error[0] }}</li>
                  </div>
                </ul>
              </v-alert>
            </div>
          </div>
          <v-row>
            <v-col cols="12">
              <label class="require">Nội dung trả lời</label>
              <quill-editor
                v-model="item.traloi"
                :options="editorOption"
                style="min-height:150px;"
              >
              </quill-editor>
            </v-col>
            <v-col cols="12">
              <v-file-input
                :disabled="existAttachFile"
                v-model="attachFile"
                accept="pdf"
                label="Văn bản kèm theo (pdf)"
                prepend-inner-icon="mdi-paperclip"
                prepend-icon=""
                messages="Lưu ý: Chỉ chấp nhận tập tin dạng: *.pdf và kích thước <= 5MB"
                outlined
              />
              <v-chip
                v-if="existAttachFile"
                class="ma-2"
                color="green"
                text-color="white"
                @click="getFile(item.attach_file)"
                close 
                @click:close="existAttachFile = false"
              >
                {{item.attach_file}}
              </v-chip>
            </v-col>
            <v-col cols="12">
              <v-text-field
                :value="item.tieude"
                label="Tiêu đề"
                outlined
                readonly
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                :value="item.branch ? item.branch.name : ''"
                label="Lĩnh vực"
                outlined
                readonly
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <label>Nội dung câu hỏi</label>
              <quill-editor 
                :options="editorOptionQuestion"
                v-model="item.noidung"
                style="min-height:80px;"
                disabled
              >
              </quill-editor>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <small><span class="pink--text">(*)</span> bắt buộc nhập</small>
        <v-spacer/>
        <v-btn
          color="pink darken-1"
          text
          @click="close"
        >
          Hủy bỏ
        </v-btn>
        <v-btn
          v-if="!readOnly && $can('reply')"
          color="primary"
          text
          @click="save(item)"
        >
          Phản hồi
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import { mapActions, mapState } from 'vuex';
  export default {
    props: {
      showDialog: {
        type: Boolean,
        default: false
      },
      item: {
        type: Object
      },
      readOnly: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        loading: false,
        dialog: false,
        errors_exist: false,
        errors: [],
        branchs: [],
        branchSelected: null,
        attachFile: null,
        existAttachFile: false,
        editorOption: {
          placeholder: 'Nhập văn bản ở đây'
        },
        editorOptionQuestion: {
          placeholder: '',
          modules: {
            toolbar: false
          }
        }
      }
    },
    computed: {
      ...mapState([
        'config'
      ])
    },
    mounted() {
      this.dialog = this.showDialog;
    },
    watch: {
      showDialog() {
        this.dialog = false;
        this.errors_exist=false;
        if (this.showDialog) {
          this.dialog = true;
          if(this.item.attach_file){
            this.existAttachFile = true;
          }
        }
      }
    },
    methods: {
      ...mapActions([
        'openSnackbar'
      ]),
      close() {
        this.dialog = false;
        this.existAttachFile=false;
        this.$emit('cancelled');
      },
      save(item) {
        const app = this;
        let url = `api/v1/supports`;
        let formData = new FormData();
        let id = item.id;
        const file = app.attachFile;
        const config = {
          headers: { 'content-type': 'multipart/form-data' }
        };

        formData.append('traloi', item.traloi ? item.traloi : '');
        formData.append('attach_file_up', file ? file : '');

        if (id) {
          url = `api/v1/supports/${id}`;
          formData.append("_method", "patch"); // for form data
        }

        app.loading=true;

        axios.post(
          url, 
          formData, 
          config
        )
          .then((response) => {
            if (response.data && response.data.id) {
              app.$emit('confirmed', response.data);
            }
            app.loading=false;
            app.openSnackbar({ type: 'success' });
          }).catch(function (error) {
            app.loading=false;
            app.openSnackbar({ type: 'error' });
            app.errors_exist = true;
            if(error.response.status === 422) {
              app.errors = error.response.data || {};
            }
          });
      },
      getFile(file){
        window.open(
          `${this.config.beUrl}/uploads/hoi-dap/${file}`,
          '_blank'
        );
      }
    }
  }
</script>